import {ReactComponent as EmptyCalendar} from '../../asset/icons/EmptyCalendar.svg'

function EmptyTrip({date, driver}: {date: string; driver: string | undefined}) {
  return (
    <div className="p-4 bg-body text-center rounded-4">
      <EmptyCalendar />
      <div className="mt-7 mb-3 fs-5 text-body">
        No trips on {date} {driver && 'for ' + driver}
      </div>
    </div>
  )
}

export default EmptyTrip
